module.exports = __webpack_public_path__ + "static/media/rate-standard.ce417893.svg";